import React from 'react';
import '../style.css';
import TopHeader from '../TopHeader';
import Navbar from '../Navbar';
import ScrollToTop from '../ScrollToTop';
import Footer from '../Footer';

const Services = () => {
  return (

    <>

    <TopHeader/>
    <Navbar/>
    
    <div className="services-container">
      <h1 className="services-title">Services</h1>

      {/* Visa Services */}
      <section className="services-section">
        <h2 className="services-heading">🛃 Visa Services</h2>
        <p className="services-text">Fast and reliable visa processing for:</p>
        <ul className="services-list">
          <li>Dubai</li>
          <li>UK</li>
          <li>Canada</li>
          <li>Europe</li>
          <li>Thailand</li>
          <li>Russia & more</li>
        </ul>
        <p className="services-text">We assist with documentation, appointment booking, and end-to-end support.</p>
      </section>

      {/* Air Ticket Booking */}
      <section className="services-section">
        <h2 className="services-heading">✈️ Air Ticket Booking</h2>
        <p className="services-text">Book the best-priced domestic and international flights. We offer:</p>
        <ul className="services-list">
          <li>Real-time fares</li>
          <li>24/7 support</li>
          <li>Group & Corporate flight deals</li>
        </ul>
      </section>

      {/* Customized Tour Packages */}
      <section className="services-section">
        <h2 className="services-heading">🌏 Customized Tour Packages</h2>
        <p className="services-text">Tailor-made travel experiences for:</p>
        <ul className="services-list">
          <li>Couples & Honeymooners</li>
          <li>Families</li>
          <li>Solo Travelers</li>
          <li>Corporate/Group Tours</li>
          <li>Student & LTC Packages</li>
        </ul>
      </section>

      {/* Passport Services */}
      <section className="services-section">
        <h2 className="services-heading">📘 Passport Services</h2>
        <p className="services-text">Help with:</p>
        <ul className="services-list">
          <li>New passport applications</li>
          <li>Renewals and reissues</li>
          <li>Lost/damaged passport recovery</li>
        </ul>
      </section>

      {/* Group & Corporate Travel */}
      <section className="services-section">
        <h2 className="services-heading">🧳 Group & Corporate Travel</h2>
        <p className="services-text">We also organize:</p>
        <ul className="services-list">
          <li>Group Tours</li>
          <li>MICE Tours</li>
          <li>Cruise Holidays</li>
          <li>Luxury Vacations</li>
        </ul>
      </section>

      {/* Tour Packages */}
      <h1 className="services-title">Tour Packages</h1>

      {/* Domestic Destinations */}
      <section className="services-section">
        <h2 className="services-heading">🧭 Domestic Destinations</h2>
        <ul className="services-list">
          <li>Himachal Tour – Shimla, Manali, Kasol</li>
          <li>Kashmir Tour – Srinagar, Gulmarg, Pahalgam</li>
          <li>Kerala Tour – Alleppey, Munnar, Thekkady</li>
          <li>Uttarakhand Tour – Mussoorie, Nainital</li>
          <li>Goa & Darjeeling Packages</li>
        </ul>
      </section>

      {/* International Destinations */}
      <section className="services-section">
        <h2 className="services-heading">✈️ International Destinations</h2>
        <ul className="services-list">
          <li>Dubai – City Tours, Desert Safari, Marina Cruise</li>
          <li>Thailand – Bangkok, Pattaya, Phuket</li>
          <li>Europe – Italy, France, Switzerland</li>
          <li>Russia – Moscow, St. Petersburg</li>
          <li>UK & Canada – Tourist & Business Travel</li>
          <li>Maldives, Bali, Singapore – Romantic and luxury escapes</li>
        </ul>
      </section>

      {/* Special Categories */}
      <section className="services-section">
        <h2 className="services-heading">💖 Special Categories</h2>
        <ul className="services-list">
          <li>Honeymoon Packages</li>
          <li>Group Tours</li>
          <li>Corporate/MICE Tours</li>
          <li>Cruise Holidays</li>
          <li>LTC Packages</li>
          <li>Family Holidays</li>
          <li>Budget to Luxury Plans</li>
        </ul>
      </section>

      {/* Call to Action */}
      <div className="services-enquire">
        <p> Need a Quote?</p>
       <p>Call Us on <strong>+91 9999116868</strong> to start planning.</p>
      </div>
    </div>

    <ScrollToTop/>
    <Footer/>
    </>
  );
};

export default Services;
